<mat-card class="shadow-lg">
  <mat-card-title>
    <div class="text-center mb-4">
      <img mat-card-md-image src="assets/images/Foodxain_logo.png" />
    </div>
  </mat-card-title>

  <mat-card-content>
    <form [formGroup]="form">
      <div class="row">
        <mat-form-field class="col-12">
          <input
            formControlName="mail"
            type="email"
            matInput
            placeholder="Email"
          />
        </mat-form-field>

        <mat-error *ngIf="emailHasErrors" class="col-12">
          <p *ngIf="isEmailRequired">Email es un campo obligatorio</p>
          <p *ngIf="isFormatInvalid">No es un email valido</p>
        </mat-error>
      </div>

      <div class="row">
        <mat-form-field class="col-12">
          <input
            formControlName="password"
            matInput
            type="password"
            placeholder="Contraseña"
          />
        </mat-form-field>

        <mat-error *ngIf="passwordHasErrors" class="col-12">
          <p *ngIf="isPasswordRequired">Contraseña es un campo obligatorio</p>
        </mat-error>
      </div>

      <div class="row" *ngIf="errorMessages">
        <mat-error class="col-sm-12">
          <p *ngFor="let message of errorMessages.messages">
            {{ message }}
          </p>
        </mat-error>
      </div>

      <div class="row">
        <div class="col-12">
          <button
            (click)="onClickSubmit()"
            [disabled]="isInvalidForm"
            mat-flat-button
            color="primary"
            class="btn-block"
          >
            Entrar
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
